import { render, staticRenderFns } from "./home_page.vue?vue&type=template&id=380d7b07&scoped=true"
import script from "./home_page.vue?vue&type=script&lang=js"
export * from "./home_page.vue?vue&type=script&lang=js"
import style0 from "./home_page.vue?vue&type=style&index=0&id=380d7b07&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d7b07",
  null
  
)

export default component.exports